import { motion } from "framer-motion";

interface ProductTourProgressProps {
  currentIndex: number;
  totalSteps: number;
}

export function ProductTourProgress({
  currentIndex,
  totalSteps,
}: ProductTourProgressProps) {
  return (
    <div className="flex items-center gap-1.5">
      {Array.from({ length: totalSteps }, (_, i) => (
        <motion.div
          key={i}
          className="rounded-full"
          animate={{
            width: i === currentIndex ? 20 : 6,
            height: 6,
            backgroundColor:
              i === currentIndex
                ? "hsl(var(--sidebar-primary))"
                : i < currentIndex
                  ? "rgba(255,255,255,0.5)"
                  : "rgba(255,255,255,0.2)",
          }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        />
      ))}
    </div>
  );
}
